import { CircularProgress, Grid } from '@mui/material';
import React from 'react';

export default function LoadingSpinner({ style }: { style?: React.CSSProperties }) {
    return (
        <Grid container alignItems="center" justifyContent="center" xs={12} style={{ padding: 20, ...style }}>
            <Grid item>
                <CircularProgress />
            </Grid>
        </Grid>
    );
}
